__turbopack_context__.v({
  "btn": "login-module-scss-module__dYXwOq__btn",
  "checkboxGroup": "login-module-scss-module__dYXwOq__checkboxGroup",
  "forgotPasswordLink": "login-module-scss-module__dYXwOq__forgotPasswordLink",
  "formGroup": "login-module-scss-module__dYXwOq__formGroup",
  "login": "login-module-scss-module__dYXwOq__login",
  "loginWindow": "login-module-scss-module__dYXwOq__loginWindow",
  "socialBtn": "login-module-scss-module__dYXwOq__socialBtn",
  "socialLogin": "login-module-scss-module__dYXwOq__socialLogin",
  "title": "login-module-scss-module__dYXwOq__title",
});
